async function initBO(){
    // console.log('initBO')
    let currentProduct = await getCurrentProduct();
    if( !currentProduct ) return;
    // console.log('currentProduct',currentProduct)
    let data_backorder_products_el = document.querySelector('[data-backorder-products]');
    let backorderProducts;
    if( data_backorder_products_el ){
        backorderProducts = data_backorder_products_el.getAttribute('data-backorder-products').split(',');
        // console.log('-_-_-_--__---__----__-- backorderProducts',backorderProducts)
    }
    if( backorderProducts.includes(currentProduct) ){
        // console.log('currentProductIsBackordered')
        let option_group__label = document.querySelector('input[name="colors"][checked]').closest('.product-form__input').querySelector('.form__label');
        if( !option_group__label ) return;
        setBackorderBubble(option_group__label);
    }else{
        return;
    }

    const mutationCallbackBO = async (mutationsList) => {
        let data_attribute = "href"
        for (const mutation of mutationsList) {
            if (
            mutation.type !== "attributes" ||
            mutation.attributeName !== "href"
            ) {
            return
            }
            let new_value = mutation.target.getAttribute("href");
            if ( new_value && new_value != null ) {
                let product = await getCurrentProduct();

                let option_group__label = document.querySelector('input[name="colors"][checked]').closest('.product-form__input').querySelector('.form__label');

                if( backorderProducts.includes(new_value) ){
                    setBackorderBubble(option_group__label);
                }else{
                    resetBackorderBubbles();
                }
            }else{
            }
        }
    }
    
    const observerBO = new MutationObserver(mutationCallbackBO)

    function addObserverIfDesiredNodeAvailableBO() {
        var composeBox = document.querySelector('a.product__title');
        if(!composeBox) {
            //The node we need does not exist yet.
            //Wait 500ms and try again
            window.setTimeout(addObserverIfDesiredNodeAvailableBO,500);
            return;
        }
        // var config = {childList: true};
        observerBO.observe(composeBox, { attributes: true })
    }
    addObserverIfDesiredNodeAvailableBO();
}

function resetBackorderBubbles(){
    let backOrderBubbles = document.querySelectorAll('.backorder-bubble');
    if( backOrderBubbles ) {
        backOrderBubbles.forEach(el => {
            el.parentNode.removeChild(el);
        });
    }
    let productAccordions = document.querySelector('.product-accordions');
    if( productAccordions) productAccordions.classList.remove('show-backorder');
    removeNotifyButton();
    if( document.getElementById('backorder-settings') ) document.getElementById('backorder-settings').classList.add('hide');
}

async function getCurrentProduct(){
    let productDisplaySection = document.querySelector('.product__info-wrapper');
    if( !productDisplaySection ) return;
    // console.log('productDisplaySection',productDisplaySection)
    let productHandleElement = productDisplaySection.querySelector('.product__title a');
    if( !productHandleElement ) return;
    // console.log('productHandleElement',productHandleElement)
    productHandle = productHandleElement.getAttribute('href');
    productHandle = productHandle.replace('/products/','');
    // console.log('productHandle',productHandle);
    return productHandle;
}

function setBackorderBubble( container ){
    // console.log('sbb',container)
    resetBackorderBubbles();
    const backorderEl = document.createElement("div");
    backorderEl.innerText = "On backorder";
    backorderEl.classList.add('backorder-bubble');
    container.append(backorderEl);

    let productAccordions = document.querySelector('.product-accordions');
    if( productAccordions ) productAccordions.classList.add('show-backorder');

    addNotifyButton();
    if(document.getElementById('backorder-settings')) document.getElementById('backorder-settings').classList.remove('hide');
}

async function addNotifyButton(){

    let buttonContainer = document.querySelector('.product-form__buttons');
    // let buttonContainer = buttonContainerParent.querySelector('>div');
    let button = document.createElement('button');
        button.innerText = 'Notify Me';
        button.id = 'backorder-notify-me-button';
        button.classList.add('button', 'button--secondary', 'button--full');
        button.addEventListener('click',function(e){
            e.preventDefault();
            showBISForm();
        });
    // get current variant id
    let product_display_wrapper = document.querySelector('.product-display-wrapper');
    let currentVariantId;
    // if( product_display_wrapper ){
    //     currentVariantId = product_display_wrapper.getAttribute('data-current-pseudo-variant-product-id');
    //     button.setAttribute('data-variant-id',currentVariantId)
    // }
    // let productJson = document.getElementById('current-variant-json-escaped').getAttribute('data-product-json');
    // if( productJson ){
    //     button.setAttribute('data-product-data',productJson);
    // }
    //add form
    let oldForm = document.getElementById('email-me-when-back-in-stock-form');
    // console.log('oldForm,',oldForm)
    if( !oldForm ){
        let newForm = document.createElement('form');
            newForm.id = 'email-me-when-back-in-stock-form';
            newForm.classList.add('hidden');
        let emailInput = document.createElement('input');
            emailInput.setAttribute('type','email');
            emailInput.setAttribute('required','required');
            emailInput.setAttribute('placeholder','Your Email Address');
            emailInput.id = 'bis-form-email';
        let emailInputLabel = document.createElement('label');
            emailInputLabel.setAttribute('for','bis-form-email');
            emailInputLabel.textContent = 'Email Address';
        let consentBox = document.createElement('div');
            consentBox.id = 'consent-box-form';
        let checkboxLabel = document.createElement('label');
            checkboxLabel.setAttribute('type','checkbox');
            checkboxLabel.setAttribute('for','email-input-checkbox');
            checkboxLabel.textContent = 'Sign-up for OOFOS newsletters to be the first to know about new releases and exclusive offers.';
        let checkbox = document.createElement('input');
            checkbox.id = 'email-input-checkbox';
            checkbox.setAttribute('type','checkbox');

        let submitForm = document.createElement('input');
            submitForm.setAttribute('type','submit');
            submitForm.classList.add('button','button--secondary','button--full-width','button-full');
            submitForm.value = 'Email me when it’s back in stock';
            submitForm.addEventListener('click',async function(f){
                f.preventDefault();
                var shopifyDomain = 'oofos.myshopify.com';
                var email = document.getElementById('bis-form-email').value;
                var productId = document.querySelector('input[type="hidden"][name="product-id"]').value;
                var customerAcceptsMarketing = document.getElementById('email-input-checkbox').value ? 'true' : 'false';
                let sizeSelection = document.querySelector('#email-me-when-back-in-stock-form').closest('.product__info-wrapper').querySelector('input[name^="Size-1"]:checked').value;
                //data-current-pseudo-variant-product-handle
                // let currentVariantHandle = document.querySelector('.product-display-wrapper').getAttribute('data-current-pseudo-variant-product-handle');
                let currentVariantHandle = document.querySelector('#email-me-when-back-in-stock-form').closest('.product__info-wrapper').querySelector('a.product__title').getAttribute('href').replace('/products/','');

                // get current product variants
                let currentProduct = await fetch(`/products/${currentVariantHandle}.json`);
                let productData = await currentProduct.json();
                // console.log(productData)
                var variantId = productData.product.variants.find( variant => variant.option1 == sizeSelection).id

                var endpoint = `https://app.backinstock.org/stock_notification/create.json?shop=${shopifyDomain}&notification[email]=${email}&notification[product_no]=${productId}&notification[quantity_required]=1&notification[accepts_marketing]=${customerAcceptsMarketing}&notification[customer_utc_offset]=10800&variant[variant_no]=${variantId}`;

                fetch(endpoint).then(function(response) {
                    return response.json();
                }).then(function(data) {
                    // console.log(data);
                    if(data.status == 'Error') {
                        let errorMessage = document.createElement('div');
                            errorMessage.classList.add('error-message');
                        let errors_text = '';
                        if( data.errors.email ){
                            errors_text = 'The email address you entered is invalid';
                        }else{
                            errors_text = 'An error has occurred. Please try again later.'
                        }
                        errorMessage.textContent = errors_text;
                        newForm.append(errorMessage)
                    }else{
                        let successMessage = document.createElement('div');
                            successMessage.classList.add('success-message');
                        let success_text = 'Thank you! You will be notified when this item is back in stock.';
                        successMessage.textContent = success_text;
                        newForm.append(successMessage)
                        newForm.classList.add('success-form');
                    }
                })
                /*.catch(function(err) {
                    
                    // let theForm = document.getElementById('email-me-when-back-in-stock-form');
                    // console.log('theForm',theForm)
                    
                    console.error('Fetch error: ',err)
                });
                */

                // console.log('endpoint',endpoint);
            });
        newForm.append(emailInputLabel);
        newForm.append(emailInput);
        consentBox.append(checkbox);
        consentBox.append(checkboxLabel);
        newForm.append(consentBox);
        newForm.append(submitForm);
        buttonContainer.append(newForm);
        //const endpoint = `https://app.backinstock.org/stock_notification/create.json?shop=${shopifyDomain}&notification[email]=${email}&notification[product_no]=${productId}&notification[quantity_required]=1&notification[accepts_marketing]=${customerAcceptsMarketing}&notification[customer_utc_offset]=10800&variant[variant_no]=${variantId}`;
        buttonContainer.append(button);
    }else{
        buttonContainer.append(button);
    }


        if (window.innerWidth < 768) {
        if( !document.getElementById('backorder-notify-me-button--mobile--container') ) {
            let buttonMoileContainer = document.createElement('div');
                buttonMoileContainer.id = 'backorder-notify-me-button--mobile--container';
            let buttonMobile = document.createElement('button');
                buttonMobile.innerText = 'Notify Me';
                buttonMobile.id = 'backorder-notify-me-button--mobile';
                buttonMobile.classList.add('button', 'button--secondary', 'button--full','notify-sticky');
                buttonMobile.addEventListener('click',function(e){
                    e.preventDefault();
                    document.querySelector('form.product-form').scrollIntoView();
                    showBISForm();
                });
            buttonMoileContainer.append(buttonMobile)
            let refNode = document.querySelector('form.product-form >span.u-sr-only');
            refNode.parentNode.insertBefore(buttonMoileContainer, refNode);
        }
    }

}
function removeNotifyButton(){
    // console.log('removeNotifyButton');
    let notifyButton = document.getElementById('backorder-notify-me-button');
    if( notifyButton ) {
        notifyButton.parentNode.removeChild(notifyButton);
    }
    let notifyButtonMobile = document.getElementById('backorder-notify-me-button--mobile');
    if( notifyButtonMobile ) {
        notifyButtonMobile.parentNode.removeChild(notifyButtonMobile);
    }
    let oldForm = document.getElementById('email-me-when-back-in-stock-form');
    if( oldForm ){
        oldForm.parentNode.removeChild(oldForm);
    }
}
function showBISForm(){
    let form = document.getElementById('email-me-when-back-in-stock-form');
    if( form ){
        form.classList.remove('hidden');
        form.classList.add('shown');
    }
}
var desktopQuery,mobileQuery;
if( !desktopQuery) {
    desktopQuery = window.matchMedia("(min-width: 768px)");
}
if( !mobileQuery) {
    var mobileQuery = window.matchMedia("(max-width: 767px)");
}

async function handleDeviceChangeDesktop(e) {
    if (e.matches) {
        await initBO();
    }
}
async function handleDeviceChangeMobile(e,size) {
    if (e.matches) {
        await initBO();
    }
}

// Listen for any screen width changes
desktopQuery.addEventListener("change", handleDeviceChangeDesktop);
mobileQuery.addEventListener("change", handleDeviceChangeMobile);

window.addEventListener('load', async function() {
    await initBO();
});